import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NoOrders from "../../../home/components/orders/NoOrders"
import {Spin} from "antd"
import BatchList from "./BatchList"

class BatchTable extends Component {

    _renderTableContent = () => {
        const {orders, loading, reloadItems, statusBatch} = this.props

        if (orders.length === 0 && !loading) {
            return <NoOrders loading={loading}/>
        }

        return <BatchList orders={orders} reloadItems={reloadItems} statusBatch={statusBatch}/>
    }

    render() {
        const tableContent = this._renderTableContent()

        const {loading} = this.props

        return (
            <div className='OrdersTable overflow-auto'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped OrdersTable'>
                        <thead className='thead-light'>
                        <tr>
                            <th className='Template'>Template</th>
                            <th className='MockUp'>Mock up</th>
                            <th>Product type</th>
                            <th>Size</th>
                            <th>File in</th>
                            <th>File in bù chi tiết</th>
                            <th>Quá hạn</th>
                            <th>Ngày in ép</th>
                            <th>Ngày QC</th>
                            <th>Trạng thái</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

BatchTable.propTypes = {
    orders: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired
}

export default BatchTable